(() => {
const $973b254601fecd3f$var$$ = jQuery;
const $973b254601fecd3f$var$_window = $973b254601fecd3f$var$$(window);
const $973b254601fecd3f$var$Menu = {
    $dom: {
        container: $973b254601fecd3f$var$$("#site-navigation"),
        menu_toggle: $973b254601fecd3f$var$$(".menu-toggle"),
        body: $973b254601fecd3f$var$$("body"),
        menu: undefined,
        links: undefined,
        sub_menus: undefined
    },
    vars: {
        activated_screen_resolution: 1199,
        show_arrows_on_desktop: false
    },
    initDom: function() {
        $973b254601fecd3f$var$Menu.$dom.menu = $973b254601fecd3f$var$Menu.$dom.container.find("ul").eq(0);
        $973b254601fecd3f$var$Menu.$dom.links = $973b254601fecd3f$var$Menu.$dom.menu.find("a");
        $973b254601fecd3f$var$Menu.$dom.sub_menus = $973b254601fecd3f$var$Menu.$dom.menu.find("ul");
    },
    appendArrows: function() {
        if ($973b254601fecd3f$var$_window.width() <= $973b254601fecd3f$var$Menu.vars.activated_screen_resolution || $973b254601fecd3f$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $973b254601fecd3f$var$Menu.$dom.container.find("li.menu-item-has-children");
            items_has_children.each(function() {
                if ($973b254601fecd3f$var$$(this).find(".arrow-toggle").length > 0) return;
                var $parent = this;
                var $arrow = $973b254601fecd3f$var$$("<span class='arrow-toggle'><span class='arrow-toggle--icon'></span></span>");
                $973b254601fecd3f$var$$(this).prepend($arrow);
                $arrow.on("click", function() {
                    $973b254601fecd3f$var$$($parent).toggleClass("expandeds");
                    $973b254601fecd3f$var$$($parent).find("> .sub-menu").slideToggle(500);
                });
            });
        } else $973b254601fecd3f$var$$(".arrow-toggle").remove();
    },
    toggleMenu: function() {
        $973b254601fecd3f$var$Menu.$dom.menu_toggle.on("click", function(e) {
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.toggleClass("is-active");
            $973b254601fecd3f$var$Menu.$dom.body.toggleClass("menu-active");
            $973b254601fecd3f$var$Menu.$dom.container.toggleClass("toggled");
            e.stopPropagation();
        });
    },
    closeMenu: function() {
        if ($973b254601fecd3f$var$$(this).attr("href") != "#" && $973b254601fecd3f$var$$(this).attr("href") != "") {
            $973b254601fecd3f$var$Menu.$dom.body.removeClass("menu-active");
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.removeClass("is-active");
            $973b254601fecd3f$var$Menu.$dom.container.removeClass("toggled");
        }
    },
    bindScrollResize: function() {
        $973b254601fecd3f$var$_window.on("resize", function() {
            $973b254601fecd3f$var$Menu.appendArrows();
        });
    },
    bindClicks: function() {
        $973b254601fecd3f$var$$(document).on("click", $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.$dom.links.on("click", $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.toggleMenu();
        $973b254601fecd3f$var$Menu.$dom.container.find("> div").click(function(e) {
            e.stopPropagation();
        });
    },
    init: function() {
        $973b254601fecd3f$var$Menu.initDom();
        $973b254601fecd3f$var$Menu.appendArrows();
        $973b254601fecd3f$var$Menu.bindClicks();
        $973b254601fecd3f$var$Menu.bindScrollResize();
    }
};
var $973b254601fecd3f$export$2e2bcd8739ae039 = $973b254601fecd3f$var$Menu;


const $cb6de554e11ef79b$var$$ = jQuery;
const $cb6de554e11ef79b$var$Theme = {
    dom: {
        shareLink: $cb6de554e11ef79b$var$$(".share-buttons a"),
        smoothScrollLinks: $cb6de554e11ef79b$var$$('a[href*="#"]:not(.gallery-category)')
    },
    /**************************************************
    * Share links
    **************************************************/ share: function() {
        $cb6de554e11ef79b$var$$(".share-buttons a").on("click", function(e) {
            if (!$cb6de554e11ef79b$var$$(this).hasClass("btn-email")) {
                e.preventDefault();
                $cb6de554e11ef79b$var$Theme.PopupCenter($cb6de554e11ef79b$var$$(this).attr("href"), $cb6de554e11ef79b$var$$(this).attr("title"), 500, 300);
            }
        });
    },
    /**************************************************
    * Share links popup
    **************************************************/ PopupCenter: function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, "scrollbars=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
        // Puts focus on the newWindow
        if (window.focus) newWindow.focus();
    },
    /**************************************************
    * Smooth scroll
    ***************************************************/ smooth_scroll: function() {
        $cb6de554e11ef79b$var$Theme.dom.smoothScrollLinks// Remove links that don't actually link to anything
        .not('[href="#"]').not('[href="#0"]').click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $cb6de554e11ef79b$var$$(this.hash);
                target = target.length ? target : $cb6de554e11ef79b$var$$("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $cb6de554e11ef79b$var$$("html, body").animate({
                        scrollTop: target.offset().top
                    }, 1000, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $cb6de554e11ef79b$var$$(target);
                        $target.focus();
                        if ($target.is(":focus")) // Checking if the target was focused
                        return false;
                        else {
                            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    });
                }
            }
        });
    },
    /**************************************************
    * Fix Height on smaller devices
    **************************************************/ fix_mobile_height: function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.addEventListener('resize', ()=>{
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
    },
    /**************************************************
    * Initial all theme functions
    **************************************************/ init: function() {
        $cb6de554e11ef79b$var$Theme.share();
        $cb6de554e11ef79b$var$Theme.smooth_scroll();
        $cb6de554e11ef79b$var$Theme.fix_mobile_height();
    }
};
var $cb6de554e11ef79b$export$2e2bcd8739ae039 = $cb6de554e11ef79b$var$Theme;


const $746bb6da1b444b48$var$$ = jQuery;
const $746bb6da1b444b48$var$Faq = {
    init: function() {
        $746bb6da1b444b48$var$$(".question").on("click", (e)=>{
            const parent = $746bb6da1b444b48$var$$(e.target).closest(".section-faq--items-item");
            const content = parent.find(".answer");
            const activeItem = $746bb6da1b444b48$var$$(".section-faq--items-item.active");
            if (!parent.hasClass("active")) {
                if (activeItem.length > 0) {
                    const activeContent = activeItem.find(".answer");
                    activeContent.slideUp();
                    activeItem.removeClass("active");
                }
                content.slideDown();
                parent.addClass("active");
            } else {
                content.slideUp();
                parent.removeClass("active");
            }
        });
    }
};
var $746bb6da1b444b48$export$2e2bcd8739ae039 = $746bb6da1b444b48$var$Faq;


const $af2513a10556e1aa$var$$ = jQuery;
const $af2513a10556e1aa$var$LoadMore = {
    getHashFilter: ()=>{
        var matches = location.hash.match(/filter=([^&]+)/i);
        var hashFilter = matches && matches[1];
        return hashFilter && decodeURIComponent(hashFilter);
    },
    init: function() {
        const isotopGrid = $af2513a10556e1aa$var$$(".image-group");
        isotopGrid.isotope({
            layoutMode: "fitRows",
            itemSelector: ".gallery-img"
        });
        const initHash = $af2513a10556e1aa$var$LoadMore.getHashFilter();
        if (initHash && initHash != "") {
            isotopGrid.isotope({
                filter: initHash == "gallery-cat-all" ? "*" : `.${initHash}`
            });
            $af2513a10556e1aa$var$$(".gallery-category").removeClass("active");
            $af2513a10556e1aa$var$$(".gallery-category#" + initHash).addClass("active");
        }
        $af2513a10556e1aa$var$$(".gallery-category").on("click", function() {
            const _this = $af2513a10556e1aa$var$$(this);
            const parent = _this.parent();
            const allItems = parent.find(".gallery-category");
            allItems.removeClass("active");
            _this.addClass("active");
            const filterClass = _this.attr("id");
            isotopGrid.isotope({
                filter: filterClass == "gallery-cat-all" ? "*" : `.${filterClass}`
            });
            location.hash = "filter=" + encodeURIComponent(filterClass);
        });
    }
};
var $af2513a10556e1aa$export$2e2bcd8739ae039 = $af2513a10556e1aa$var$LoadMore;


const $538ea2323a48fb5c$var$$ = jQuery;
const $538ea2323a48fb5c$var$Slider = {
    init: function() {
        $538ea2323a48fb5c$var$$(document).ready(function() {
            if (window.matchMedia('(max-width: 570px)').matches) $538ea2323a48fb5c$var$$('.section-single-gallery--categories').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                speed: 500,
                arrows: false,
                centerMode: false,
                variableWidth: true,
                infinite: false
            });
            // section-our-team--items
            if (window.matchMedia('(max-width: 767px)').matches) $538ea2323a48fb5c$var$$('.section-our-team--items').slick({
                arrows: false,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                prevArrow: '<div class="arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="#0C331F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
                nextArrow: '<div class="arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#0C331F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
                responsive: [
                    {
                    }
                ]
            });
            if (window.matchMedia('(max-width: 767px)').matches) {
                const waitForThumbs = setInterval(function() {
                    const $thumbs = $538ea2323a48fb5c$var$$('.woocommerce-product-gallery .flex-control-nav.flex-control-thumbs');
                    if ($thumbs.length > 0 && !$thumbs.hasClass('slick-initialized')) {
                        clearInterval(waitForThumbs); // zaustavi proveru kada se element pronađe
                        $thumbs.slick({
                            arrows: false,
                            dots: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            prevArrow: '<div class="arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="#0C331F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
                            nextArrow: '<div class="arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#0C331F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
                        });
                    }
                }, 200);
            }
            $538ea2323a48fb5c$var$$('.auto-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 500,
                arrows: true,
                prevArrow: '<div class="arrow prev-arrow"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="29.5" transform="rotate(-180 30 30)" stroke="#161817"/><path d="M33 24L27 30L33 36" stroke="#161817" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
                nextArrow: '<div class="arrow next-arrow"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="29.5" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 60)" stroke="#161817"/><path d="M27 24L33 30L27 36" stroke="#161817" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
                responsive: [
                    {
                        breakpoint: 638,
                        settings: {
                            arrows: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true
                        }
                    }
                ]
            });
            const $parentWrapper = $538ea2323a48fb5c$var$$('.section-product-slider--box');
            const $slider = $parentWrapper.find('.slider-content');
            $slider.on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide) {
                const slideA = nextSlide ? nextSlide : currentSlide;
                let nextElement = $slider.find(`[data-slick-index="${slideA}"]`);
                let nextElement3 = nextElement.next();
                let nextElement4 = nextElement3.next();
                let nextElement1 = nextElement.prev();
                let nextElement0 = nextElement1.prev();
                if (nextSlide == 0 && (currentSlide == 1 || currentSlide == 5)) {
                    nextElement = $slider.find(`[data-slick-index="${slideA}"]`);
                    nextElement3 = $slider.find(`[data-slick-index="1"]`);
                    nextElement4 = $slider.find(`[data-slick-index="2"]`);
                    nextElement1 = $slider.find(`[data-slick-index="-1"]`);
                    nextElement0 = $slider.find(`[data-slick-index="-2"]`);
                }
                if (event.type == 'init') setTimeout(()=>{
                    $slider.slick('slickNext');
                }, 200);
                $parentWrapper.find('.slick-slide').removeClass('slick-active-0 slick-active-1 slick-active-2 slick-active-3 slick-active-4');
                nextElement3.addClass('slick-active-3');
                nextElement4.addClass('slick-active-4');
                nextElement1.addClass('slick-active-1');
                nextElement0.addClass('slick-active-0');
            });
            $slider.on('afterChange', function(e, slick, current) {
                // pause all
                $slider.find('video').each((i, v)=>v.pause());
                const video = slick.$slider.get(0).querySelector('.slick-current video');
                video?.play();
            });
            $slider.slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0px',
                prevArrow: $parentWrapper.find('.prev'),
                nextArrow: $parentWrapper.find('.next'),
                focusOnSelect: true,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: false,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            centerMode: true,
                            arrows: false,
                            focusOnSelect: true
                        }
                    }
                ]
            });
        });
    }
};
var $538ea2323a48fb5c$export$2e2bcd8739ae039 = $538ea2323a48fb5c$var$Slider;


const $314b7d8ee9fcdb95$var$$ = jQuery;
const $314b7d8ee9fcdb95$var$_window = $314b7d8ee9fcdb95$var$$(window);
const $314b7d8ee9fcdb95$var$PriceSlider = {
    findClosest (array, value) {
        return array.reduce((closest, current)=>Math.abs(current - value) < Math.abs(closest - value) ? current : closest);
    },
    init: ()=>{
        const select = $314b7d8ee9fcdb95$var$$('select[name="attribute_pa_custom-pricing"]');
        if (select && select.length > 0) {
            const options = select.find('option');
            const initalValue = select.val();
            let steps = 0;
            let isSwiping = false;
            const values = options.map(function() {
                if ($314b7d8ee9fcdb95$var$$(this).val() != '') return parseInt($314b7d8ee9fcdb95$var$$(this).val());
            }).get().sort((a, b)=>a - b);
            steps = values.length;
            const sliderWrapperWrapper = $314b7d8ee9fcdb95$var$$('<div class="main-price-slider" />');
            const sliderWrapper = $314b7d8ee9fcdb95$var$$('<div id="price-slider" />');
            const sliderSwipe = $314b7d8ee9fcdb95$var$$('<span id="price-slider-swipe" />');
            const sliderSwipeHolder = $314b7d8ee9fcdb95$var$$('<span id="price-slider-holder" />');
            sliderWrapper.append(sliderSwipeHolder);
            sliderWrapper.append(sliderSwipe);
            sliderWrapperWrapper.append(sliderWrapper);
            select.after(sliderWrapperWrapper);
            const calcPosition = (e, firstStep = null)=>{
                var parentPosition = sliderWrapper.offset();
                var parentWidth = sliderWrapper.width();
                const stepWidth = parentWidth / steps;
                const startPx = 25;
                const endOffsetPx = 40;
                const stepSize = (parentWidth - 50) / steps;
                let parentWidthSteps = [];
                for(let index = 1; index <= steps; index++)if (index == 1) parentWidthSteps.push(25);
                else parentWidthSteps.push(index * stepSize);
                console.log(parentWidthSteps);
                if (firstStep) {
                    const calcPosition = parentWidthSteps[values.indexOf(parseInt(firstStep))];
                    // const realPosition = (calcPosition / parentWidth) * 100;
                    const realPosition = `calc(${startPx}px + ${100 - endOffsetPx * 100 / parentWidth}% * 0)`;
                    sliderSwipe.css(`left`, `${realPosition}`);
                    sliderSwipeHolder.css(`width`, `${realPosition}`);
                    for(let index = 0; index < values.length; index++){
                        const price = values[index];
                        const frac = index / (steps - 1);
                        const positionItem = index == 0 ? 30 / parentWidth * 100 : (index + 1) * stepSize / parentWidth * 100;
                        const $item = $314b7d8ee9fcdb95$var$$('<span class="price-item" style="left:' + `calc(${startPx}px + ${100 - endOffsetPx * 100 / parentWidth}% * ${frac})` + ';">' + price + '</span>');
                        sliderWrapper.append($item);
                    }
                    return;
                }
                const offsetPage = e.pageX;
                let position = offsetPage - parentPosition.left;
                if (position <= 0) position = 0;
                if (parentWidth + parentPosition <= position) position = parentWidth + parentPosition;
                const realPosition = $314b7d8ee9fcdb95$var$PriceSlider.findClosest(parentWidthSteps, position) / parentWidth * 100;
                const step = parentWidthSteps.indexOf($314b7d8ee9fcdb95$var$PriceSlider.findClosest(parentWidthSteps, position));
                console.log(step);
                const frac2 = step / (steps - 1);
                const realPosition2 = `calc(${startPx}px + ${100 - endOffsetPx * 100 / parentWidth}% * ${frac2})`;
                console.log(realPosition2);
                sliderSwipe.css(`left`, `${realPosition2}`);
                sliderSwipeHolder.css(`width`, `${realPosition2}`);
                select.val(values[step]).trigger('change');
            };
            calcPosition(null, initalValue);
            sliderWrapper.on('dragend click', function(e) {
                calcPosition(e);
            });
        }
    }
};
var $314b7d8ee9fcdb95$export$2e2bcd8739ae039 = $314b7d8ee9fcdb95$var$PriceSlider;


const $27e8ca04f50302c4$var$$ = jQuery;
let $27e8ca04f50302c4$var$InputNumber = {
    var: {
        min: 0,
        max: null,
        step: 1
    },
    dom: {
        inputs: $27e8ca04f50302c4$var$$('input[type="number"]')
    },
    increase: ($input)=>{
        const currentVal = parseFloat($input.val());
        const newValue = currentVal + $27e8ca04f50302c4$var$InputNumber.var.step;
        if ($27e8ca04f50302c4$var$InputNumber.var.max != null && newValue <= $27e8ca04f50302c4$var$InputNumber.var.max || $27e8ca04f50302c4$var$InputNumber.var.max == null) {
            $input.val(newValue);
            $input.trigger("change");
        }
    },
    decrease: ($input)=>{
        const currentVal = parseFloat($input.val());
        const newValue = currentVal - $27e8ca04f50302c4$var$InputNumber.var.step;
        if ($27e8ca04f50302c4$var$InputNumber.var.min <= newValue) {
            $input.val(newValue);
            $input.trigger("change");
        }
    },
    makeDom: ()=>{
        for(let index = 0; index < $27e8ca04f50302c4$var$$('input[type="number"]').length; index++){
            const $inputWrapper = $27e8ca04f50302c4$var$$('<div class="input-wrapper" />');
            const $this = $27e8ca04f50302c4$var$$($27e8ca04f50302c4$var$$('input[type="number"]')[index]);
            const $quanitity = $27e8ca04f50302c4$var$$('<span class="quantity-text>Kolicina: </span>');
            const $plus = $27e8ca04f50302c4$var$$(`<svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.12 7.624H3.904V4.584H0.72V3.464H3.904V0.424H5.12V3.464H8.304V4.584H5.12V7.624Z" fill="#0C331F"/>
</svg>
`);
            const $minus = $27e8ca04f50302c4$var$$(`<svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.568 1.584H0.72V0.464H7.568V1.584Z" fill="#0C331F"/>
</svg>
`);
            if ($this.attr("min") && $this.attr("min") != "") $27e8ca04f50302c4$var$InputNumber.var.min = parseFloat($this.attr("min"));
            if ($this.attr("max") && $this.attr("max") != "") $27e8ca04f50302c4$var$InputNumber.var.max = parseFloat($this.attr("max"));
            if ($this.attr("step") && $this.attr("step") != "") $27e8ca04f50302c4$var$InputNumber.var.step = parseFloat($this.attr("step"));
            $this.wrapAll($inputWrapper);
            const $parent = $this.parent();
            $parent.append($plus);
            $parent.append($minus);
            $plus.on("click", ()=>{
                $27e8ca04f50302c4$var$InputNumber.increase($this);
            });
            $minus.on("click", ()=>{
                $27e8ca04f50302c4$var$InputNumber.decrease($this);
            });
        }
    },
    init: function() {
        $27e8ca04f50302c4$var$InputNumber.makeDom();
        $27e8ca04f50302c4$var$$("body").on("updated_wc_div", function() {
            console.log("SSS");
            $27e8ca04f50302c4$var$InputNumber.makeDom();
        });
    }
};
var $27e8ca04f50302c4$export$2e2bcd8739ae039 = $27e8ca04f50302c4$var$InputNumber;


const $75fed4258e681378$var$$ = jQuery;
const $75fed4258e681378$var$Woocommerce = {
    init: function() {
        $75fed4258e681378$var$$(".variation-radios input").on("change", function(element) {
            // $(".variation-radios input:checked").each(function (index, element) {
            const $el = $75fed4258e681378$var$$(this);
            const thisName = $el.attr("name");
            const thisVal = $el.attr("value");
            let parent = $el.closest(".variations_form");
            if ($75fed4258e681378$var$$(document.body).hasClass("single")) {
                parent = $75fed4258e681378$var$$(".variations_form");
                console.log(parent);
            }
            parent.find('select[name="' + thisName + '"]').val(thisVal).trigger("change");
        // });
        });
        $75fed4258e681378$var$$(document).on("woocommerce_update_variation_values", function() {
            $75fed4258e681378$var$$(".variation-radios input").each(function(index, element) {
                var $el = $75fed4258e681378$var$$(element);
                var thisName = $el.attr("name");
                var thisVal = $el.attr("value");
                $el.removeAttr("disabled");
                if ($75fed4258e681378$var$$('select[name="' + thisName + '"] option[value="' + thisVal + '"]').is(":disabled")) $el.prop("disabled", true);
            });
        });
        const observer = new MutationObserver(()=>{
            let images = $75fed4258e681378$var$$(".flex-control-nav.flex-control-thumbs img");
            if (images.length > 0) {
                images.each(function() {
                    this.removeAttribute("sizes");
                    this.style.width = "auto";
                    this.style.height = "auto";
                });
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};
var $75fed4258e681378$export$2e2bcd8739ae039 = $75fed4258e681378$var$Woocommerce;


const $d09d858c661d4008$var$$ = jQuery;
const $d09d858c661d4008$var$DeliveryPrice = {
    init: function() {
        $d09d858c661d4008$var$$(".delivery-price").on("click", function(e) {
            e.stopPropagation();
            let content = $d09d858c661d4008$var$$(this).siblings(".section-delivery-price");
            if (!content.length) content = $d09d858c661d4008$var$$(".section-delivery-price");
            if (content.hasClass("active")) $d09d858c661d4008$var$DeliveryPrice.close(content);
            else {
                $d09d858c661d4008$var$$(".section-delivery-price").removeClass("active").css("transform", "translateX(100%)");
                content.addClass("active").css("transform", "translateX(0)");
                $d09d858c661d4008$var$$("body").addClass("delivery-price-active");
            }
        });
        $d09d858c661d4008$var$$(".section-delivery-price").on("click", ".icon-close", function() {
            const content = $d09d858c661d4008$var$$(this).closest(".section-delivery-price");
            $d09d858c661d4008$var$DeliveryPrice.close(content);
        });
        $d09d858c661d4008$var$$(document).on("click", function(e) {
            if (!$d09d858c661d4008$var$$(e.target).closest(".section-delivery-price, .delivery-price").length) $d09d858c661d4008$var$DeliveryPrice.close($d09d858c661d4008$var$$(".section-delivery-price.active"));
        });
    },
    close: function(content) {
        content.removeClass("active").css("transform", "translateX(100%)");
        $d09d858c661d4008$var$$("body").removeClass("delivery-price-active");
    }
};
var $d09d858c661d4008$export$2e2bcd8739ae039 = $d09d858c661d4008$var$DeliveryPrice;


const $d84fa988c82da16d$var$$ = jQuery;
const $d84fa988c82da16d$var$SingleGallery = {
    init: function() {
        $d84fa988c82da16d$var$$(document).ready(function() {
            const buttons = document.querySelectorAll(".category-btn");
            const galleryImages = document.querySelectorAll(".gallery-images");
            const loadMoreBtn = document.querySelector(".btn-wrapper button");
            const IMAGES_PER_CLICK = 12;
            function showInitialImages(gallery) {
                const allImages = gallery.querySelectorAll("a");
                allImages.forEach((img, i)=>{
                    img.style.display = i < IMAGES_PER_CLICK ? "block" : "none";
                });
            }
            function showNextImages(gallery) {
                const hiddenImages = Array.from(gallery.querySelectorAll("a")).filter((a)=>a.style.display === "none");
                for(let i = 0; i < IMAGES_PER_CLICK && i < hiddenImages.length; i++)hiddenImages[i].style.display = "block";
            }
            function updateLoadMoreVisibility(gallery) {
                const hiddenImages = Array.from(gallery.querySelectorAll("a")).filter((a)=>a.style.display === "none");
                loadMoreBtn.style.display = hiddenImages.length > 0 ? "flex" : "none";
            }
            buttons.forEach((btn)=>{
                const btnId = btn.dataset.index;
                btn.addEventListener("click", ()=>{
                    buttons.forEach((b)=>b.classList.remove("active"));
                    btn.classList.add("active");
                    galleryImages.forEach((gallery)=>{
                        const allImages = gallery.querySelectorAll("a");
                        if (gallery.dataset.index === btnId) {
                            gallery.classList.add("active");
                            showInitialImages(gallery);
                            updateLoadMoreVisibility(gallery);
                        } else {
                            gallery.classList.remove("active");
                            allImages.forEach((img)=>{
                                img.style.display = "none";
                            });
                        }
                    });
                });
            });
            if (loadMoreBtn) loadMoreBtn.addEventListener("click", ()=>{
                const activeGallery = document.querySelector(".gallery-images.active");
                if (!activeGallery) return;
                showNextImages(activeGallery);
                updateLoadMoreVisibility(activeGallery);
            });
            const initialGallery = document.querySelector(".gallery-images.active");
            if (initialGallery) {
                showInitialImages(initialGallery);
                updateLoadMoreVisibility(initialGallery);
            }
        });
    }
};
var $d84fa988c82da16d$export$2e2bcd8739ae039 = $d84fa988c82da16d$var$SingleGallery;


const $72dbacbc1af1c8b0$var$$ = jQuery;
const $72dbacbc1af1c8b0$var$PopularSlider = {
    init: function() {
        $72dbacbc1af1c8b0$var$$(document).ready(function() {
            const scrollBar = document.querySelector('.scroll-bar');
            const scrollThumb = document.createElement('div');
            const products = document.querySelector('.popular-products');
            if (products) {
                const allProducts = products.querySelectorAll('.product');
                if (window.innerWidth > 991) {
                    if (!scrollBar || !products) return;
                    scrollThumb.style.position = 'absolute';
                    scrollThumb.style.height = '100%';
                    scrollThumb.style.borderRadius = '20px';
                    scrollThumb.style.backgroundColor = '#6c7564';
                    scrollThumb.style.left = 0;
                    scrollThumb.style.width = '30%';
                    scrollThumb.style.transition = 'left 0.1s ease-out';
                    if (allProducts.length > 4) scrollBar.appendChild(scrollThumb);
                    function updateThumbWidth() {
                        const ratio = products.clientWidth / products.scrollWidth;
                        scrollThumb.style.width = `${ratio * 100}%`;
                    }
                    function syncThumbPosition() {
                        const scrollRatio = products.scrollLeft / (products.scrollWidth - products.clientWidth);
                        const maxLeft = scrollBar.clientWidth - scrollThumb.offsetWidth;
                        scrollThumb.style.left = `${scrollRatio * maxLeft}px`;
                    }
                    products.addEventListener('scroll', syncThumbPosition);
                    window.addEventListener('resize', updateThumbWidth);
                    updateThumbWidth();
                    let isDragging = false;
                    let startX;
                    let startLeft;
                    scrollThumb.addEventListener('mousedown', (e)=>{
                        isDragging = true;
                        startX = e.clientX;
                        startLeft = parseFloat(scrollThumb.style.left);
                        e.preventDefault();
                    });
                    window.addEventListener('mousemove', (e)=>{
                        if (!isDragging) return;
                        const dx = e.clientX - startX;
                        const maxLeft = scrollBar.clientWidth - scrollThumb.offsetWidth;
                        let newLeft = startLeft + dx;
                        newLeft = Math.max(0, Math.min(maxLeft, newLeft));
                        scrollThumb.style.left = `${newLeft}px`;
                        const scrollRatio = newLeft / maxLeft;
                        products.scrollLeft = scrollRatio * (products.scrollWidth - products.clientWidth);
                    });
                    window.addEventListener('mouseup', ()=>{
                        isDragging = false;
                    });
                    scrollBar.addEventListener('click', (e)=>{
                        if (e.target == scrollThumb) return;
                        const rect = scrollBar.getBoundingClientRect();
                        const clickX = e.clientX - rect.left;
                        const ratio = clickX / scrollBar.clientWidth;
                        products.scrollLeft = ratio * (products.scrollWidth - products.clientWidth);
                    });
                }
            }
        });
    }
};
var $72dbacbc1af1c8b0$export$2e2bcd8739ae039 = $72dbacbc1af1c8b0$var$PopularSlider;


(0, $973b254601fecd3f$export$2e2bcd8739ae039).init();
(0, $cb6de554e11ef79b$export$2e2bcd8739ae039).init();
(0, $746bb6da1b444b48$export$2e2bcd8739ae039).init();
(0, $af2513a10556e1aa$export$2e2bcd8739ae039).init();
(0, $314b7d8ee9fcdb95$export$2e2bcd8739ae039).init();
(0, $538ea2323a48fb5c$export$2e2bcd8739ae039).init();
(0, $75fed4258e681378$export$2e2bcd8739ae039).init();
(0, $27e8ca04f50302c4$export$2e2bcd8739ae039).init();
(0, $d09d858c661d4008$export$2e2bcd8739ae039).init();
(0, $d84fa988c82da16d$export$2e2bcd8739ae039).init();
(0, $72dbacbc1af1c8b0$export$2e2bcd8739ae039).init();
const $bdaa65c8cc66fe0a$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if ($bdaa65c8cc66fe0a$var$isSafari) document.documentElement.classList.add("safari");
jQuery(document).ready(function($) {
    $("input.timepicker").timepicker({
        timeFormat: "HH:mm",
        interval: 60,
        minTime: "10:00",
        maxTime: "21:00",
        startTime: "10:00",
        dynamic: true,
        dropdown: true,
        scrollbar: true
    });
});
jQuery(document).ready(function($) {
    function moveWapfIntoForm() {
        var wapf = $(".wapf");
        var form = $(".variations .value ");
        if (wapf.length) wapf.appendTo(form);
    }
    moveWapfIntoForm();
    const maxSelections = 2;
    $(document).on("change", '.wapf input[type="checkbox"]', function() {
        const name = $(this).attr("name");
        const $checkboxGroup = $('input[name="' + name + '"]');
        const checkedCount = $checkboxGroup.filter(":checked").length;
        if (checkedCount > maxSelections) {
            this.checked = false;
            alert("Mo\u017Eete izabrati najvi\u0161e " + maxSelections + " opcije.");
            return;
        }
        // Ako je dostignut max broj selekcija, disable ostale koje nisu čekirane
        if (checkedCount === maxSelections) $checkboxGroup.not(":checked").prop("disabled", true);
        else // Omogući sve checkboxove ako nije dostignut maksimum
        $checkboxGroup.prop("disabled", false);
    });
    jQuery(function($) {
        $(".wapf-field-label label span").each(function() {
            const text = $(this).text();
            if (!text.endsWith(":")) $(this).text(text + ":");
        });
        const observer = new MutationObserver(()=>{
            $(".woo-selected-variation-item-name").each(function() {
                let text = $(this).text().trim();
                text = text.replace(/^:\s*/, "");
                if (!text.endsWith("rsd")) $(this).text(text + " rsd");
            });
        });
        if (document.querySelector("form.variations_form")) observer.observe(document.querySelector("form.variations_form"), {
            childList: true,
            subtree: true,
            characterData: true
        });
    });
    $(document.body).on("woocommerce_update_variation_values woocommerce_variation_has_changed", function() {
        moveWapfIntoForm();
    });
});
lightbox.option({
    wrapAround: true,
    showImageNumberLabel: false,
    positionFromTop: 139,
    albumLabel: false,
    disableScrolling: true
});
const $bdaa65c8cc66fe0a$var$items = document.querySelectorAll(".slider-content--item-inner");
class $bdaa65c8cc66fe0a$var$LightBoxVideo {
    constructor(){
        this.videos = {};
        this.lightBoxVideo();
    }
    lightBoxVideo = ()=>{
        this.setEvents();
        this.setMutationObserver();
    };
    setMutationObserver = ()=>{
        const observer = new MutationObserver((mutation)=>{
            const imageMutations = mutation.filter((m)=>{
                return m.attributeName === "src" && m.target.className === "lb-image";
            });
            const overlayDisplay = window.getComputedStyle(document.querySelector(".lightboxOverlay"), null).display;
            if ("none" === overlayDisplay) this.removeVideoElement();
            if (imageMutations.length > 0) {
                if (this.videos[imageMutations[0].target.src]) {
                    this.removeVideoElement();
                    this.setVideoElement(this.videos[imageMutations[0].target.src]);
                }
            }
        });
        observer.observe(document.body, {
            childList: false,
            attributes: true,
            subtree: true,
            characterData: false
        });
    };
    setEvents = ()=>{
        const videoLinks = this.findVideoLinks();
        videoLinks.forEach((link)=>{
            this.videos[link.href] = link;
            link.addEventListener("click", (e)=>{
                e.preventDefault(); // <== najvažnije
                this.removeVideoElement();
                this.setVideoElement(e.target);
            });
        });
    };
    setVideoElement = (element)=>{
        const lightbox1 = document.querySelector(".lightbox");
        const container = lightbox1.querySelector(".lb-container");
        lightbox1.classList.add("video-lightbox");
        this.removeVideoElement();
        const videoElement = this.createVideoElement(element);
        setTimeout(()=>{
            container.prepend(videoElement);
        }, 100);
        setTimeout(()=>{
            const lightboxVideo = document.querySelector(".lightbox video");
            const windowHeight = window.innerHeight / 2;
            const height = lightboxVideo.offsetHeight / 2;
            const scrollPosition = window.scrollY;
            lightbox1.style.top = `${scrollPosition + windowHeight - height}px`;
            lightbox1.querySelector(".animating").classList.remove("animating");
            lightbox1.querySelector(".lb-loader").style.display = "none";
        }, 300);
    };
    removeVideoElement = ()=>{
        const lightbox1 = document.querySelector(".lightbox");
        const container = lightbox1.querySelector(".lb-container");
        const video = container.querySelector("video");
        if (video) container.removeChild(video);
    };
    createVideoElement = (element)=>{
        const video = document.createElement("video");
        // video.setAttribute('poster', element.href);
        video.setAttribute("controls", "true");
        video.setAttribute("autoplay", "autoplay");
        video.setAttribute("playsinline", ""); // VAŽNO
        video.setAttribute("webkit-playsinline", ""); // VAŽNO za stariji iOS Safari
        const source = document.createElement("source");
        source.setAttribute("src", element.dataset.href);
        source.setAttribute("type", "video/mp4");
        video.append(source);
        return video;
    };
    findVideoLinks = ()=>{
        const hrefs = document.querySelectorAll("a[data-lightbox]");
        const regex = /\.(mp4|mov|flv|wmv)$/;
        if (0 === hrefs.length) return [];
        return Array.from(hrefs).filter((href)=>{
            return !!href.dataset.href.match(regex);
        });
    };
}
window.addEventListener("DOMContentLoaded", ()=>{
    new $bdaa65c8cc66fe0a$var$LightBoxVideo();
});

})();
//# sourceMappingURL=main.js.map
